<template>
  <md-field>
    <label>{{ label }}</label>
    <md-input
      v-model="forwardModel"
      v-on="$listeners"
      v-bind="$attrs"
      :step="step"
      type="number"
      min="0"
    >
    </md-input>
  </md-field>
</template>

<script>
import ForwardVModel from '@/mixins/ForwardVModel';

export default {
  props: {
    label: String,
    step: {
      type: String,
      default: '0.0001',
    },
  },

  mixins: [ForwardVModel],
};
</script>

<style scoped lang="scss">
